import { FC, lazy, useState } from "react"
import { useNavigate } from "react-router-dom"
import { IStudent } from "types"
import { t } from "i18next"

import { Box, Button, Grid } from "@mui/material"
import { Check, RadioButtonUnchecked } from "@mui/icons-material"

import MeetingForm from 'components/organisms/forms/MeetingForm'
import BackgroundInformationForm from 'components/organisms/forms/special/BackgroundInformationForm'
import AssessmentDataForm from 'components/organisms/forms/special/AssessmentDataForm'
import AccomodationsModificationsForm from 'components/organisms/forms/special/AccommodationsModificationsForm'
import AssessmentParticipationForm from 'components/organisms/forms/special/AssessmentParticipationForm'
import SpecialFactorsForm from 'components/organisms/forms/special/SpecialFactorsForm'
import ServiceSupportForm from 'components/organisms/forms/special/ServiceSupportForm'
import EnrollmentForm from 'components/organisms/forms/special/EnrollmentForm'
import GoalsForm from 'components/organisms/forms/special/GoalsForm'
import EligibilityDeterminationForm from 'components/organisms/forms/special/EligibilityDeterminationForm'
import ComplianceChecksForm from 'components/organisms/forms/special/ComplianceChecksForm'
import FinalizationForm from 'components/organisms/forms/special/FinalizationForm'
import PlopReportForm from "components/organisms/forms/PlopReportForm"
import RtiPlopList from "../rti/RtiPlopList"



interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const IEP: FC<IProps> = ({ student }) => {

    const navigate  =  useNavigate()

    const [step, setStep] = useState(0)

    const steps = [
        {title: t('special.iep-team-meetings'), checked: false, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.student-invitation-meeting'), checked: false, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.iep-parent-meeting'), checked: false, component: <MeetingForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.background-information'), checked: false, component: <BackgroundInformationForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.assessment-data'), checked: false, component: <AssessmentDataForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('common.present-level-of-performance'), checked: false, component: <RtiPlopList student={student} tabKey="plop" tabText={`${t('common.present-level-of-performance')}`} /> },
        {title: t('common.accommodations-and-modifications'), checked: false, component: <AccomodationsModificationsForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.assessment-participation'), checked: false, component: <AssessmentParticipationForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.consideration-of-special-factors'), checked: false, component: <SpecialFactorsForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.service-and-support'), checked: false, component: <ServiceSupportForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.enrollment'), checked: false, component: <EnrollmentForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('rti.goals'), checked: false, component: <GoalsForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.eligibility-determination'), checked: false, component: <EligibilityDeterminationForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.compliance-checks'), checked: false, component: <ComplianceChecksForm action={'add'} id={''} viewOnly={false} /> },
        {title: t('special.finalization'), checked: false, component: <FinalizationForm action={'add'} id={''} viewOnly={false} /> },
    ]


    return <div style={{ padding: '0px' }}>    
        <Grid container>
            <Grid item xs={12} lg={3}>
                <div style={{ padding: '20px' }}>
                    <div style={{ padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '5px' }}>
                        {steps.map((s, index) => <Box 
                            className='transparent-background' 
                            onClick={() => setStep(index)}
                            sx={{ 
                                display: 'flex', 
                                cursor: 'pointer', 
                                marginBottom: '20px',
                                fontWeight: step === index ? 'bold' : 'normal',
                                '&:hover': {
                                    fontWeight: 'bold'
                                }
                            }}>
                                {s.checked && <Check sx={{ color: '#7ED321', fontSize: '20px', marginRight: '10px' }} />}
                                {!s.checked && <RadioButtonUnchecked sx={{ fontSize: '20px', marginRight: '10px'  }} />}
                                {index+1}. {s.title}
                        </Box>)}

                        <Button
                            variant='outlined'
                            color='black'
                            onClick={() => navigate(`/students/edit/${student.id}`)}
                            sx={{ width: '100%', marginTop: '20px' }}
                            >
                            {`Move to general education`}
                        </Button>


                    </div>
                </div>
            </Grid>
            <Grid item xs={12} lg={9}>
                <div style={{ padding: '20px' }}>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px'}}>{step+1}. {steps[step].title}</div>
                    {steps[step].component}    
                </div>
            </Grid>
        </Grid>
    </div>
}
export default IEP